import { useCallback, useMemo, useRef, useState } from 'react';

/**
 * Hook for countdown specific amount of time (in minutes)
 * @returns
 */
const useTimer = (timeDurationInMinutes = 0) => {
  const timerRef = useRef(null);
  const [
    remainingSeconds,
    setRemainingSeconds,
  ] = useState(0);

  const timeDurationInSeconds = useMemo(() => {
    if (!timeDurationInMinutes) {
      return 0;
    }

    return timeDurationInMinutes * 60;
  }, [timeDurationInMinutes]);

  const timeDurationInMilliseconds = useMemo(() => {
    if (!timeDurationInMinutes) {
      return 0;
    }

    return timeDurationInMinutes * 60 * 1000;
  }, [timeDurationInMinutes]);

  const startTimer = useCallback(() => {
    if (timerRef.current) {
      return;
    }

    setRemainingSeconds(timeDurationInSeconds);

    timerRef.current = setInterval(() => {
      setRemainingSeconds((prev) => prev - 1);
    }, 1000);

    setTimeout(() => {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }, timeDurationInMilliseconds);
  }, [timerRef, timeDurationInSeconds]);

  return {
    remainingSeconds,
    startTimer,
  };
};

export { useTimer };
